import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  EditIcon,
  IconButton,
  List,
  ListItem,
  ListSeparator,
  Menu,
  Tooltip,
  TrashIcon,
  TreeDotsIcon,
} from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

const Target = forwardRef(({ onClick, className, open }, ref) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t("More options")}>
      <IconButton
        variant="text gray"
        onClick={onClick}
        ref={ref}
        aria-label="More"
        active={open}
        className={classNames("tw-ml-2 show-on-hover", { "tw-opacity-100": open }, className)}
      >
        <TreeDotsIcon />
      </IconButton>
    </Tooltip>
  );
});

Target.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  open: PropTypes.bool,
};

Target.displayName = "Target";

export const TemplateElementOptions = ({ onEdit, onDelete, targetClassName }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleEdit = () => {
    handleClose();
    onEdit();
  };

  const handleDelete = () => {
    handleClose();
    onDelete();
  };

  return (
    <Menu
      target={<Target className={targetClassName} />}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      mode="tiny"
    >
      <List className="tw-my-2">
        <ListItem onClick={handleEdit}>
          <EditIcon />
          {t("Edit")}
        </ListItem>
        <ListSeparator />
        <ListItem onClick={handleDelete}>
          <TrashIcon />
          {t("Delete")}
        </ListItem>
      </List>
    </Menu>
  );
};

TemplateElementOptions.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  targetClassName: PropTypes.string,
};
